import { Tag } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getDistance } from '../../api/planningApi';
import { TState, useActions } from '../../redux/store';

const DistanceTag = ({ appoint, forceDistance }: any) => {
  const rowData = useSelector((state: TState) => state.rowData);
  const modalType = useSelector((state: TState) => state.modalType);
  const planningAddress = useSelector((state: TState) => state.planningAddress);
  const isPlanningEdit = useSelector((state: TState) => state.isPlanningEdit);
  const triggerDistance = useSelector((state: TState) => state.triggerDistance);

  const { setTriggerDistance } = useActions();

  const [distance, setDistance] = useState<any>(null);
  const key = planningAddress || 'planningAddress';

  const getIt = async () => {
    if (appoint.planningAddress !== rowData[key]) {
      const resp = await getDistance({
        origin: appoint.planningAddress,
        destination: rowData[key],
      });

      if (resp.data.distance === 0) return;

      setDistance(resp.data);
    }
  };

  const notEdit =
    !isPlanningEdit && !/addToPlanning|updatePlanning/i.test(modalType);

  useEffect(() => {
    if (
      !appoint.planningAddress ||
      !rowData[key] ||
      appoint.planningAddress === rowData[key] ||
      notEdit
    ) {
      setDistance(null);
      return;
    }

    if (triggerDistance || forceDistance) {
      getIt();
    }

    setTriggerDistance(false);
  }, [rowData, triggerDistance]);

  return distance ? (
    <Tag
      fontSize='12px'
      mr={1}
      backgroundColor={/H/.test(distance.duration) ? 'red.400' : 'green.400'}
    >
      {`${distance.duration}/${distance.distance}`}
    </Tag>
  ) : null;
};

export default DistanceTag;
